<template>
	<div>
		<main>
			<section class="hero hero--job">
				<div class="container">
				</div>
			</section>

			<section class="section bg-grey">
				<div class="container main__grid job">
					<article class="job__main">
						<section>
							<main>
								<ul class="job__heading">
									<li class="boards__item">
										<div class="item__row">
											<div class="boards__head">
												JOB
											</div>
											<div class="boards__detail">
												<h5 class="bold">{{job.title}}</h5>
												<div class="boards__item__meta">
													<span class="item">
														<span class="item">
															<svg width="8" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.77 0 0 1.7 0 3.85 0 6.71 4 11 4 11s4-4.29 4-7.15A3.9 3.9 0 0 0 4 0zm0 5.22c-.8 0-1.43-.6-1.43-1.37 0-.77.63-1.38 1.43-1.38.8 0 1.43.61 1.43 1.38 0 .77-.63 1.37-1.43 1.37z" fill="#474747"/>
															</svg>
															<span>
																&nbsp; {{ job.location }}
															</span>
														</span>
													</span>
												</div>
											</div>
										</div>
										<div class="right">
											<ul class="tag">
												<li class="tag__item">{{job.type}}</li>
											</ul>
										</div>
									</li>
								</ul>
								<div class="job__meta">
									<div class="job__meta__item">
										Type:
										<span>{{job.type}}</span>
									</div>
									<div class="job__meta__item">
										Closing Date:
										<span>{{ job.closing_date | date}}</span>
									</div>
									<div class="job__meta__item">
										Status:
										<span :class="isActive">
											{{ job.active === 1 ? 'Active' : 'Not Active'}}
										</span>
									</div>
								</div>
								<div class="job__body">
									<h5 class="job__primary">Job Description</h5>
									<p v-html=job.description></p>
								</div>
							</main>
						</section>
					</article>
					<aside>
                        <template v-if="applicationStatus || !jobStatus">
                            <template v-if="applicationStatus">
                                <p>You have applied for this job.</p>
                            </template>
                            <template v-else>
                                <p>This job is currently inactive.</p>
                            </template>
                        </template>
						<template v-else>
                            <form
                            @submit.prevent="jobApplication" 
                            class="upload">
								<strong>Upload Your Resume.</strong>
                                <div class="upload__section">
                                    <div class="upload__wrapper">
                                        <input
                                            class="upload__input"
                                            role="button"
                                            @change="uploadCv"
                                            ref="cvs"
                                            type="file"
                                            placeholder="Upload File">
                                        <button
                                            type="submit"
                                            @click.prevent="jobApplication"
                                            :v-bind="{'disabled': isUploadingCv}"
                                            class="btn__primary btn__primary--upload">
                                            Apply
                                            <Loader
                                                v-if="isUploadingCv"
                                                class="loading loading--alt"/>
                                        </button>
                                    </div>
                                </div>
                                <div class="invalid-feedback">
                                    {{ errors.cv }}
                                </div>
                            </form>
                        </template>
					</aside>
				</div>
			</section>
		</main>
	</div>
</template>

<script>
import { getJobDetails, jobApplication, getJobApplicants, uploadCv } from '../../utils/api/job';
import { success, fail } from '../../utils/toast';
import Loader from '../../components/Loader';

export default {
	name: 'JobDetail',
	data() {
		return {
			job: {},
			loadingJob: true,
			jobLoaded: false,
			applicationStatus: false,
			applicants: [],
			applicantsLoaded: false,
			status: false,
			errors: {},
			resumeData: {},
			isUploadingCv: false,
			cvUploaded: false,
			resume: null,
			file: ''
		};
	},
	created() {
		this.getJobDetails();
		this.getJobApplicants();
	},
	methods: {
		getJobDetails() {
			getJobDetails(this.$route.params.id)
				.then((response) => {
					if (response.status === 200) {
						this.jobLoaded = true;
						this.job = response.data.data;
					}
					this.loadingJob = false;
					return false;
				})
				.catch((error) => {
					this.loadingJob = false;
					return error;
				});
			return true;
		},
		jobApplication() {
			const data = {
				user_id: this.$session.get('id'),
				resume: this.resume
			};
			jobApplication(this.$route.params.id, data)
				.then((response) => {
					if (response.status === 201) {
						this.applicationStatus = true;
						success({
							title: 'Success! You have successfully applied!.'
						});
					}
				}).catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
				});
		},
		getJobApplicants() {
			const userId = this.$session.get('id');
			getJobApplicants(this.$route.params.id)
				.then((response) => {
					if (response.status === 200) {
						this.applicants = response.data.data;
						this.applicantsLoaded = true;
						this.applicants.map((applicant) => {
							if (applicant.user_id === userId) {
								this.applicationStatus = true;
							}
							return true;
						});
						return true;
					}
					this.applicantsLoaded = false;
					return false;
				}).catch((error) => {
					Promise.reject(error.response);
					this.applicantsLoaded = false;
				})
				.finally(() => {
					this.applicantsLoaded = false;
				});
		},
		uploadCv() {
			const [file] = this.$refs.cvs.files;
			this.file = file;
			const formData = new FormData();
			formData.append('file', this.file);
			this.isUploadingCv = true;
			this.cvUploaded = false;
			uploadCv(formData)
				.then((response) => {
					if (response.status === 200) {
						this.resume = response.data.file;
						this.isUploadingCv = false;
						this.cvUploaded = true;
						return true;
					}
					this.cvUploaded = false;
					return false;
				})
				.catch((error) => {
					this.cvUploaded = false;
					return error;
				})
				.finally(() => {
					this.isUploadingCv = false;
				});
			return true;
		}
	},
	filters: {
		date(value) {
			return moment(value).fromNow();
		}
	},
	computed: {
		isActive() {
			return [
				this.job.active === 1
					? 'badge badge-success'
					: 'badge badge-danger'
			];
		},
		jobStatus() {
			if (this.job.active === 1 && moment(this.job.closing_date).isAfter(new Date())) {
				this.status = true;
				return true;
			}
			return false;
		}
	},
	components: {
		Loader
	}
};
</script>

<style lang="scss" scoped>
.job__heading.item{
	span {
		padding-left: 5px;
	}
}
.job__meta__item {
	font-size: 16px;
	span {
		padding-left: 5px;
		text-transform: capitalize;
	}
}
button:disabled {
	background: lightgrey;
	color: #fff;
	&:hover {
		cursor: not-allowed;
	}
}
.upload {
	&__wrapper {
		position: relative;
		overflow: hidden;
		display: inline-block;
		display: flex;
		flex-direction: column;
	}
}
.upload__input {
	top: 0;
	font-size: 12px;
	margin: auto;
	bottom: 0;
	left: 0;
	@media #{$mobile} {
		margin-left: 0;
		margin-bottom: 10px;
	}
	&:hover {
		cursor: pointer;
	}
}
</style>
